import { UserPermission } from "@/models/userPermission";
import hasAnyOfPermissions from "@/functional/permissions/hasAnyOfPermissions";

export default (userPermissions: string[]): boolean => {
  return hasAnyOfPermissions(userPermissions, [
    UserPermission.superAdmin,
    UserPermission.viewOrganisationUsers,
  ]);
};
